export default "__VITE_ASSET__Dc2IEbug__"